import {
  calendar_month_picker_styles_default
} from "./chunk.P2FJQO6Q.js";
import {
  emit
} from "./chunk.C4ZTYQN4.js";
import {
  o
} from "./chunk.OBPYZVEK.js";
import {
  n,
  t
} from "./chunk.D5EJUUKV.js";
import {
  $,
  s
} from "./chunk.4JTBA2KG.js";
import {
  __decorateClass
} from "./chunk.K2NRSETB.js";

// src/components/calendar/calendar-month-picker.ts
import { t as t2 } from "i18next";
var FadvCalendarMonthPicker = class extends s {
  constructor() {
    super(...arguments);
    this.mode = "month";
    this.keyboardSelection = false;
  }
  handleKeydown(event) {
    const month = this.state.workingDate.getMonth();
    let monthDiff = 0;
    switch (event.key) {
      case "ArrowUp":
        monthDiff = -4;
        break;
      case "ArrowDown":
        monthDiff = 4;
        break;
      case "ArrowLeft":
        monthDiff = -1;
        break;
      case "ArrowRight":
        monthDiff = 1;
        break;
      case "Home":
        monthDiff = 1 - month;
        break;
      case "End":
        monthDiff = 12 - month;
        break;
      case "PageUp":
        monthDiff = event.altKey ? -120 : -12;
        break;
      case "PageDown":
        monthDiff = event.altKey ? 120 : 12;
        break;
      default:
        return;
    }
    event.preventDefault();
    event.stopPropagation();
    this.keyboardSelection = true;
    emit(this, "fadv-date-changed", { detail: { date: new Date(this.state.workingDate.setMonth(month + monthDiff)) } });
  }
  handleNextClick() {
    this.keyboardSelection = false;
    this.emitDateChange(new Date(this.state.workingDate.setFullYear(this.state.workingDate.getFullYear() + 1)));
  }
  handlePrevClick() {
    this.keyboardSelection = false;
    this.emitDateChange(new Date(this.state.workingDate.setFullYear(this.state.workingDate.getFullYear() - 1)));
  }
  createMonthSelectedHandler(month) {
    return () => {
      this.keyboardSelection = false;
      this.emitDateChange(new Date(this.state.workingDate.getFullYear(), month, this.state.workingDate.getDate()), "date");
    };
  }
  emitDateChange(date, mode) {
    emit(this, "fadv-date-changed", { detail: { date, mode } });
  }
  handleLabelClick() {
    emit(this, "fadv-cal-nav-mode-change");
  }
  focus(options) {
    var _a, _b;
    const month = this.state.workingDate.getMonth();
    const monthName = t2(`components:calendar.monthsFull.${month}`);
    const label = `${monthName} ${this.state.workingDate.getFullYear()}`;
    (_b = (_a = this.shadowRoot) == null ? void 0 : _a.querySelector(`button[aria-label="${label}"]`)) == null ? void 0 : _b.focus(options);
  }
  renderMonth(index) {
    var _a, _b;
    const month = this.state.workingDate.getMonth();
    const year = this.state.workingDate.getFullYear();
    const isCurrentMonth = index === this.state.currentDate.getMonth() && year === this.state.currentDate.getFullYear();
    const isSelectedMonth = index === ((_a = this.state.selectedDate) == null ? void 0 : _a.getMonth()) && year === ((_b = this.state.selectedDate) == null ? void 0 : _b.getFullYear());
    const isActive = index === this.state.workingDate.getMonth();
    return $`<button class=${o({
      "calendar-month-picker__month": true,
      "calendar-month-picker__month-current": isCurrentMonth,
      "calendar-month-picker__month-selected": isSelectedMonth,
      "calendar-month-picker__active": this.keyboardSelection && isActive
    })} @click=${this.createMonthSelectedHandler(index)} role="gridcell" aria-label="${t2(`components:calendar.monthsFull.${index}`)} ${this.state.workingDate.getFullYear()}" tabindex=${index === month ? "0" : "-1"} ><fadv-typography type="label-medium">${t2(`components:calendar.monthsShort.${index}`)}</fadv-typography></button>`;
  }
  render() {
    return $`<div class="calendar-month-picker"><div class="calendar-navigator"><div class="calendar-navigator__title"><button @click=${this.handleLabelClick}><fadv-typography variant="primary" type="heading-small" weight="500">${this.state.workingDate.getFullYear()}</fadv-typography></button></div><div class="calendar-navigator__controls"><button aria-label=${t2("components:calendar.yearPrevious")} @click=${this.handlePrevClick}><fadv-icon size="small" foreground="primary" library="solid" name="fa-chevron-left"></fadv-icon></button><button aria-label=${t2("components:calendar.yearNext")} @click=${this.handleNextClick}><fadv-icon size="small" foreground="primary" library="solid" name="fa-chevron-right"></fadv-icon></button></div></div><div role="grid" class="calendar-month-picker__months" @keydown=${this.handleKeydown}>${Array.from({ length: 12 }).map((_, i) => this.renderMonth(i))}</div></div>`;
  }
};
FadvCalendarMonthPicker.styles = calendar_month_picker_styles_default;
__decorateClass([
  t()
], FadvCalendarMonthPicker.prototype, "state", 2);
__decorateClass([
  t()
], FadvCalendarMonthPicker.prototype, "keyboardSelection", 2);
FadvCalendarMonthPicker = __decorateClass([
  n("fadv-calendar-month-picker")
], FadvCalendarMonthPicker);

export {
  FadvCalendarMonthPicker
};
